import React from 'react'
import sppedr from "../Assets/3563394.png"
import elec_gen from "../Assets/a_4.png"
import "./CSS/Electric_Generator.css"

const Electric_generator = () => {
    return (
        <section className="electric-generator-section-genrator-1">
            <div className="middle-of-elec-generetor-section">
                <div className="top-of-middle">
                    <div className="cFret-widgets">
                        <h4>Jeneratör Durum</h4>
                        <div className="cFret-widgets-pointers">
                            <div>
                                <p>Jeneratör Devir</p>
                                <img src={sppedr} alt="" />
                                <a style={{color:"black",textDecoration:"none"}} href="#">1255 rpm</a>
                            </div>
                            <div>
                                <p>Yağ Sıcaklığı</p>
                                <img src={sppedr} alt="" />
                                <a style={{color:"black",textDecoration:"none"}} href="#">80 °C</a>
                            </div>
                            <div>
                                <p>Yağ Basıncı</p>
                                <img src={sppedr} alt="" />
                                <a style={{color:"black",textDecoration:"none"}} href="#">5.5 bar</a>
                            </div>
                        </div>
                    </div>
                    <div className="cFret-widgets">
                        <h4>Faz Voltajları</h4>
                        <div className="cFret-widgets-pointers">
                        <div>
                                <p>L1</p>
                                <img src={sppedr} alt="" />
                                <a style={{color:"black",textDecoration:"none"}} href="#">221 V</a>
                            </div>
                            <div>
                                <p>L2</p>
                                <img src={sppedr} alt="" />
                                <a style={{color:"black",textDecoration:"none"}} href="#">222 V</a>
                            </div>
                            <div>
                                <p>L3</p>
                                <img src={sppedr} alt="" />
                                <a style={{color:"black",textDecoration:"none"}} href="#">223 V</a>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="bottom-of-middle_electric_generator">
                    <img src={elec_gen} alt="" />
                    <div className="yakit-seviyesi">
                        <p>Yakıt Seviyesi</p>
                        <div className="yakit-seviyesi-bottom-div">
                            55.0 %
                        </div>
                    </div>
                    <div className="egzost-cikis-sicakligi">
                        <p>Egzost Çıkış Sıcaklığı</p>
                        <div className="egzost-cikis-sicakligi-right">
                            225.1 °C
                        </div>
                    </div>
                    <div className="control-mode">
                        <div className="control-mode-divs">
                            Kontrol Modu <select ><option value="local">LOCAL</option></select>
                        </div>
                        <div className="control-mode-divs">
                            Kumanda <div>Start</div> <input type="checkbox" />
                        </div>
                        <div className="control-mode-divs">
                            Jeneratör Kapasite <div>50.0 %</div>
                        </div>
                        <div className="control-mode-divs">
                            Çalışma Zamanı <div>570.0 hr</div>
                        </div>
                        <div className="control-mode-divs">
                            Bekleme Zamanı <div> 120.0 hr</div> <input type="checkbox" />
                        </div>

                    </div>
                    <div className="ariza-durumu">
                        <h4 style={{width:"100%",float:"left",marginTop:"-4px"}}>Arıza Durumu</h4>
                        <div className="ariz-durumu-divs">Genel Arıza Durumu <div>ALARM</div><input type="checkbox" name="" id="" /></div>
                        <div className="ariz-durumu-divs">Acil Durum Shutdown <div>Normal</div><input type="checkbox" name="" id="" /></div>
                        <div className="ariz-durumu-divs">Yüksek Basınç <div>normal</div><input type="checkbox" name="" id="" /></div>
                        <div className="ariz-durumu-divs">Yakıt Seviyesi <div>alarm</div><input type="checkbox" name="" id="" /></div>
                        <div className="ariz-durumu-divs">Batarya Şarj <div>normal</div><input type="checkbox" name="" id="" /></div>
                        <div className="ariz-durumu-divs">Yüksek RPM <div>normal</div><input type="checkbox" name="" id="" /></div>

                    </div>
                </div>

            </div>
        </section>
    )
}

export default Electric_generator